import type { FC } from 'react';
import type { PlainAction } from '@components/types';
import { ReactTable } from '@pages/User/components';
import type { QueryStatus } from '@tanstack/react-query';

import type { TeamRecord } from '../types';
import { getTeamsTableColumns } from '../utils/get-teams-table-columns';

interface UserTeamsProps {
  createAction: PlainAction;
  isEmpty: boolean;
  onEdit: (team: TeamRecord) => void;
  status: QueryStatus;
  teams: TeamRecord[];
}

export const UserTeams: FC<UserTeamsProps> = ({ createAction, isEmpty, onEdit, status, teams }) => (
  <ReactTable
    actions={[createAction]}
    columns={getTeamsTableColumns(onEdit)}
    columnPinning={{ right: ['edit'] }}
    createEntityAction={createAction}
    enableColumnFilters={false}
    entityName="team"
    filteredData={teams}
    initialSorting={[{ id: 'id', desc: false }]}
    isEmpty={isEmpty}
    status={status}
  />
);
